import { ALL_SUBJECT_CONFIG_MAP } from '@patsnap/synapse_common_config'

export const sortSubject = (subjectKey1: string, subjectKey2: string) => {
  const aRank = ALL_SUBJECT_CONFIG_MAP[subjectKey1]?.rank || -1
  const bRank = ALL_SUBJECT_CONFIG_MAP[subjectKey2]?.rank || -1
  return aRank - bRank
}
